<template>
  <Index />
</template>

<script setup>
import Index from '@/components/app/dashboard/Index.vue';

await new Promise((r) => setTimeout(r, 0));
</script>
